// ============================================
// UTIL - Alerta de turnos antiguos al abrir caja
// ============================================
// Si el almacén tiene un turno abierto hace más de 3 días, el backend responde 409 con este código
// la primera vez; el cliente debe pedir confirmación y reenviar la apertura con `confirmado: true`.

import type { ApiError } from '@almacenes/core';

export const esConfirmacionTurnoAntiguo = (err: unknown): err is ApiError =>
  (err as ApiError | undefined)?.code === 'TURNO_ANTIGUO_CONFIRMACION_REQUERIDA';
